
import { defineComponent } from "vue";
import Modal from "../Components/Modal.vue";
import gameApplication from "../../game/game-app";
import { GameStage } from "../../types/game-stage-enum";
import { useStore } from "@/stores";
import { RoomItem } from "@/types/room-item";

export default defineComponent({
  name: "JoinTournamentModal",

  methods: {
    onAccept(): void {
      const store = useStore();
      const tournamentRoom: RoomItem = store.state.tournamentRoom;
      const registered: boolean = store.state.isRegistered;

      gameApplication.sendAcceptTournament(tournamentRoom.roomId, registered);
      
      this.$emit('close');
    },

    onDecline(): void {     
      this.$emit('close');
    },

    getModalText(): string {
      let modalText;   
  
      try {
        if (gameApplication.getGameStage() === GameStage.GameInProgress) {
          modalText = 'Quit current game now?';
        } else {
          modalText =  'Join the tournament?';
        }
      } catch (err) {
        modalText =  'Join the tournament?';
      }

      return modalText;
    },
  },

  components: { Modal },
});
